import Icon3 from "assets/images/magento.png";
import Icon1 from "assets/images/paypal.png";
import Icon4 from "assets/images/shopify.png";
import Icon2 from "assets/images/wix.png";
import Icon5 from "assets/images/woo.png";

export const integrationsList = [
   {
      id: 1,
      icon: Icon1,
      alt: "Paypal",
   },
   {
      id: 2,
      icon: Icon2,
      alt: "Wix",
   },
   {
      id: 3,
      icon: Icon3,
      alt: "Magento",
   },
   {
      id: 4,
      icon: Icon4,
      alt: "Shopify",
   },
   {
      id: 5,
      icon: Icon5,
      alt: "Woo Commerce",
   },
];
